// src/themes/platformThemes.js

export const THEMES = {
  // 1. CLASSIC DARK
  DARK: {
    name: "Dark",
    bg: "bg-gray-950",
    card: "bg-gray-900",
    nav: "bg-gray-900",
    text: "text-gray-100",
    subText: "text-gray-300",
    accent: "text-teal-400",
    accentBg: "bg-teal-600",
    border: "border-gray-700",
    glow: "shadow-teal-500/30",
    hover: "hover:bg-gray-800",
    tabHover: "hover:bg-teal-600 hover:text-white",
    buttonPrimary: "bg-teal-600 hover:bg-teal-700 text-white",
    buttonSecondary: "bg-gray-800 hover:bg-gray-700 text-gray-200",
    tabActive: "bg-teal-600 text-white border-teal-400 shadow-lg",
    tabInactive: "bg-gray-800 text-gray-300 border-gray-700",
    danger: "bg-red-600 text-white",
    success: "bg-emerald-500 text-white",
    warning: "bg-amber-400 text-black",
  },

  // 2. LIGHT
  LIGHT: {
    name: "Light",
    bg: "bg-gray-50",
    card: "bg-white",
    nav: "bg-white",
    text: "text-gray-900",
    subText: "text-gray-600",
    accent: "text-blue-700",
    accentBg: "bg-blue-600",
    border: "border-gray-200",
    glow: "shadow-blue-500/10",
    hover: "hover:bg-gray-100",
    tabHover: "hover:bg-blue-600 hover:text-white",
    buttonPrimary: "bg-blue-600 hover:bg-blue-700 text-white",
    buttonSecondary: "bg-gray-200 hover:bg-gray-300 text-gray-800",
    tabActive: "bg-blue-600 text-white border-blue-500 shadow-lg",
    tabInactive: "bg-gray-100 text-gray-700 border-gray-200",
    danger: "bg-red-600 text-white",
    success: "bg-emerald-600 text-white",
    warning: "bg-amber-400 text-black",
  },

  // 3. MIDNIGHT OPS
  MIDNIGHT_OPS: {
    name: "Midnight Ops",
    bg: "bg-slate-950",
    card: "bg-slate-900",
    nav: "bg-slate-950",
    text: "text-slate-100",
    subText: "text-slate-400",
    accent: "text-cyan-400",
    accentBg: "bg-cyan-700",
    border: "border-slate-700",
    glow: "shadow-cyan-500/30",
    hover: "hover:bg-slate-800",
    tabHover: "hover:bg-cyan-600 hover:text-white",
    buttonPrimary: "bg-cyan-600 hover:bg-cyan-700 text-white",
    buttonSecondary: "bg-slate-800 hover:bg-slate-700 text-slate-200",
    tabActive: "bg-cyan-600 text-white border-cyan-400 shadow-lg",
    tabInactive: "bg-slate-800 text-slate-300 border-slate-700",
    danger: "bg-red-700 text-white",
    success: "bg-emerald-600 text-white",
    warning: "bg-amber-500 text-black",
  },

  // 4. SYNTHWAVE AI
  SYNTHWAVE_AI: {
    name: "Synthwave AI",
    bg: "bg-black",
    card: "bg-fuchsia-950/60",
    nav: "bg-black",
    text: "text-pink-200",
    subText: "text-cyan-300",
    accent: "text-fuchsia-400",
    accentBg: "bg-fuchsia-600",
    border: "border-fuchsia-500/50",
    glow: "shadow-fuchsia-500/40",
    hover: "hover:bg-fuchsia-900/70",
    tabHover: "hover:bg-fuchsia-600 hover:text-white",
    buttonPrimary: "bg-fuchsia-600 hover:bg-fuchsia-700 text-white",
    buttonSecondary: "bg-cyan-950 hover:bg-cyan-900 text-cyan-200",
    tabActive: "bg-fuchsia-600 text-white border-fuchsia-400 shadow-lg shadow-fuchsia-500/50",
    tabInactive: "bg-fuchsia-950/60 text-pink-200 border-cyan-500/40",
    danger: "bg-red-600 text-white",
    success: "bg-emerald-500 text-white",
    warning: "bg-yellow-400 text-black",
  },

  // 5. SOFT PASTEL
  SOFT_PASTEL: {
    name: "Soft Pastel",
    bg: "bg-rose-50",
    card: "bg-white",
    nav: "bg-rose-100",
    text: "text-rose-950",
    subText: "text-rose-700",
    accent: "text-violet-500",
    accentBg: "bg-violet-500",
    border: "border-rose-200",
    glow: "shadow-violet-400/30",
    hover: "hover:bg-rose-100",
    tabHover: "hover:bg-violet-600 hover:text-white",
    buttonPrimary: "bg-violet-500 hover:bg-violet-600 text-white",
    buttonSecondary: "bg-rose-200 hover:bg-rose-300 text-rose-900",
    tabActive: "bg-violet-500 text-white border-violet-400 shadow-lg",
    tabInactive: "bg-rose-100 text-rose-800 border-rose-200",
    danger: "bg-red-500 text-white",
    success: "bg-emerald-500 text-white",
    warning: "bg-amber-400 text-black",
  },

  // 6. DEEPTECH BLACK
  DEEPTECH_BLACK: {
    name: "DeepTech Black",
    bg: "bg-zinc-950",
    card: "bg-black",
    nav: "bg-zinc-950",
    text: "text-lime-200",
    subText: "text-zinc-400",
    accent: "text-lime-400",
    accentBg: "bg-lime-600",
    border: "border-zinc-800",
    glow: "shadow-lime-500/40",
    hover: "hover:bg-zinc-900",
    tabHover: "hover:bg-lime-600 hover:text-white",
    buttonPrimary: "bg-lime-600 hover:bg-lime-700 text-white",
    buttonSecondary: "bg-zinc-900 hover:bg-zinc-800 text-zinc-100",
    tabActive: "bg-lime-600 text-white border-lime-400 shadow-lg",
    tabInactive: "bg-black text-lime-200 border-zinc-800",
    danger: "bg-red-700 text-white",
    success: "bg-emerald-600 text-white",
    warning: "bg-amber-500 text-black",
  },

  // 7. COGNITIVE GLASS
  COGNITIVE_GLASS: {
    name: "Cognitive Glass",
    bg: "bg-slate-950",
    card: "bg-white/10 backdrop-blur-xl",
    nav: "bg-slate-950/80 backdrop-blur-lg",
    text: "text-cyan-100",
    subText: "text-slate-300",
    accent: "text-cyan-300",
    accentBg: "bg-cyan-500/80",
    border: "border-white/20",
    hover: "hover:bg-white/10 hover:text-white",
    tabActive: "bg-cyan-500 text-white border-cyan-300 shadow-lg shadow-cyan-500/40",
    tabInactive: "bg-white/5 text-cyan-100 border-white/10 hover:bg-cyan-600 hover:text-white",
    tabHover: "hover:bg-cyan-600 hover:text-white",
    tableHeader: "bg-cyan-500/20 text-cyan-100 border-white/10",
    tableRow: "bg-white/5 text-cyan-50 border-white/10 hover:bg-white/10 hover:text-white",
    buttonPrimary: "bg-cyan-500 hover:bg-cyan-600 text-white",
    buttonSecondary: "bg-white/10 hover:bg-cyan-600 hover:text-white text-cyan-100",
    danger: "bg-red-600/90 text-white",
    success: "bg-emerald-500/90 text-white",
    warning: "bg-amber-400/90 text-black",
    glow: "shadow-cyan-400/50",
  },

 // 8. EMERGENCY CRIMSON
  EMERGENCY_CRIMSON: {
    name: "Emergency Crimson",
    bg: "bg-red-950",
    card: "bg-red-900",
    nav: "bg-black",
    text: "text-red-100",
    subText: "text-red-300",
    accent: "text-yellow-300",
    accentBg: "bg-red-700",
    border: "border-red-700",
    glow: "shadow-red-600/50",
    hover: "hover:bg-red-800",
    tabHover: "hover:bg-red-600 hover:text-white",
    buttonPrimary: "bg-red-700 hover:bg-red-800 text-white",
    buttonSecondary: "bg-zinc-900 hover:bg-black text-red-200",
    tabActive: "bg-red-700 text-white border-red-400 shadow-lg shadow-red-600/50",
    tabInactive: "bg-red-900 text-red-200 border-red-700",
    danger: "bg-yellow-400 text-black",
    success: "bg-emerald-500 text-white",
    warning: "bg-amber-400 text-black",
  },

  // 9. HOLOGRAPHIC FUTURE
  HOLOGRAPHIC_FUTURE: {
    name: "Holographic Future",
    bg: "bg-gradient-to-br from-slate-950 via-indigo-950 to-cyan-950",
    card: "bg-white/10 backdrop-blur-2xl",
    nav: "bg-black/40 backdrop-blur-xl",
    text: "text-cyan-100",
    subText: "text-violet-200",
    accent: "text-fuchsia-300",
    accentBg: "bg-fuchsia-600",
    border: "border-cyan-400/30",
    glow: "shadow-fuchsia-500/60",
    hover: "hover:bg-white/5 hover:text-cyan-100",
    tabHover: "hover:bg-fuchsia-600 hover:text-white",
    buttonPrimary: "bg-fuchsia-600 hover:bg-fuchsia-700 text-white",
    buttonSecondary: "bg-cyan-500 hover:bg-cyan-600 text-black",
    tabActive: "bg-fuchsia-600 text-white border-cyan-300 shadow-2xl shadow-fuchsia-500/60",
    tabInactive: "bg-white/5 text-cyan-100 border-cyan-400/20 hover:bg-fuchsia-600 hover:text-white",
    danger: "bg-red-600 text-white",
    success: "bg-emerald-500 text-white",
    warning: "bg-amber-400 text-black",
  },

  // 10. LIQUID INTELLIGENCE
  LIQUID_INTELLIGENCE: {
    name: "Liquid Intelligence",
    bg: "bg-gradient-to-br from-cyan-100 via-blue-50 to-violet-100",
    card: "bg-white/70 backdrop-blur-xl",
    nav: "bg-white/50 backdrop-blur-lg",
    text: "text-slate-900",
    subText: "text-slate-600",
    accent: "text-cyan-700",
    accentBg: "bg-cyan-600",
    border: "border-white/50",
    glow: "shadow-cyan-400/40",
    hover: "hover:bg-cyan-100/80 hover:text-slate-900",
    tabHover: "hover:bg-cyan-600 hover:text-white",
    buttonPrimary: "bg-cyan-600 hover:bg-cyan-700 text-white",
    buttonSecondary: "bg-violet-600 hover:bg-violet-700 text-white",
    tabActive: "bg-cyan-600 text-white border-cyan-500 shadow-lg shadow-cyan-400/50",
    tabInactive: "bg-white/60 text-slate-900 border-white/50 hover:bg-cyan-600 hover:text-white",
    danger: "bg-red-600 text-white",
    success: "bg-emerald-600 text-white",
    warning: "bg-amber-500 text-black",
  },

   // 11. BHARAT BRIGHT - Strong saffron-orange with deep green accents (Tricolor energy)
  BHARAT_BRIGHT: {
    name: "Bharat Bright",
    bg: "bg-orange-50",
    card: "bg-white",
    nav: "bg-gradient-to-r from-orange-600 via-amber-500 to-green-600 text-white",
    text: "text-orange-950",
    subText: "text-green-800",
    accent: "text-green-700",
    accentBg: "bg-green-700",
    border: "border-orange-300",
    glow: "shadow-orange-600/40",
    hover: "hover:bg-orange-100",
    tabHover: "hover:bg-green-700 hover:text-white",
    buttonPrimary: "bg-green-700 hover:bg-green-800 text-white",
    buttonSecondary: "bg-orange-600 hover:bg-orange-700 text-white",
    tabActive: "bg-green-700 text-white border-green-600 shadow-lg shadow-green-600/50",
    tabInactive: "bg-white text-orange-950 border-orange-300 hover:bg-green-700 hover:text-white",
    tableHeader: "bg-gradient-to-r from-orange-600 to-green-700 text-white",
    tableRow: "bg-white text-orange-950 border-orange-200 hover:bg-orange-50",
    danger: "bg-red-600 text-white",
    success: "bg-green-700 text-white",
    warning: "bg-amber-500 text-black",
  },

  // 12. SOFT NEUMORPH
  SOFT_NEUMORPH: {
    name: "Soft Neumorph",
    bg: "bg-slate-200",
    card: "bg-slate-200 shadow-[8px_8px_20px_#a1b0c0,-8px_-8px_20px_#ffffff]",
    nav: "bg-slate-200",
    text: "text-slate-800",
    subText: "text-slate-600",
    accent: "text-indigo-700",
    accentBg: "bg-indigo-600",
    border: "border-slate-300",
    glow: "shadow-indigo-400/30",
    hover: "hover:shadow-[inset_6px_6px_12px_#a1b0c0,inset_-6px_-6px_12px_#ffffff] hover:text-slate-900",
    tabHover: "hover:bg-indigo-600 hover:text-white",
    buttonPrimary: "bg-indigo-600 hover:bg-indigo-700 text-white shadow-[4px_4px_8px_#a1b0c0,-4px_-4px_8px_#ffffff]",
    buttonSecondary: "bg-slate-300 hover:bg-slate-400 text-slate-800",
    tabActive: "bg-indigo-600 text-white border-indigo-400 shadow-lg shadow-indigo-400/40",
    tabInactive: "bg-slate-200 text-slate-800 border-slate-300 hover:bg-indigo-600 hover:text-white hover:shadow-inner",
    danger: "bg-red-500 text-white",
    success: "bg-emerald-600 text-white",
    warning: "bg-amber-400 text-black",
  },

  // 13. DORM RETRO
  DORM_RETRO: {
    name: "Dorm Retro",
    bg: "bg-amber-50",
    card: "bg-orange-100",
    nav: "bg-amber-200",
    text: "text-amber-950",
    subText: "text-orange-800",
    accent: "text-red-700",
    accentBg: "bg-red-600",
    border: "border-amber-400",
    glow: "shadow-orange-500/40",
    hover: "hover:bg-orange-200",
    tabHover: "hover:bg-red-600 hover:text-white",
    buttonPrimary: "bg-red-600 hover:bg-red-700 text-white",
    buttonSecondary: "bg-amber-500 hover:bg-amber-600 text-amber-950",
    tabActive: "bg-red-600 text-white border-red-500 shadow-lg shadow-red-500/40",
    tabInactive: "bg-orange-100 text-amber-950 border-amber-400 hover:bg-red-600 hover:text-white",
    danger: "bg-red-700 text-white",
    success: "bg-emerald-600 text-white",
    warning: "bg-amber-400 text-black",
  },

  // 14. AUTUMN HARVEST
  AUTUMN_HARVEST: {
    name: "Autumn Harvest",
    bg: "bg-orange-50",
    card: "bg-yellow-100",
    nav: "bg-orange-200",
    text: "text-orange-950",
    subText: "text-amber-800",
    accent: "text-orange-700",
    accentBg: "bg-orange-700",
    border: "border-amber-300",
    glow: "shadow-orange-500/40",
    hover: "hover:bg-orange-100",
    tabHover: "hover:bg-orange-700 hover:text-white",
    buttonPrimary: "bg-orange-700 hover:bg-orange-800 text-white",
    buttonSecondary: "bg-amber-600 hover:bg-amber-700 text-amber-950",
    tabActive: "bg-orange-700 text-white border-orange-600 shadow-lg shadow-orange-500/40",
    tabInactive: "bg-yellow-100 text-orange-950 border-amber-300 hover:bg-orange-700 hover:text-white",
    danger: "bg-red-600 text-white",
    success: "bg-emerald-600 text-white",
    warning: "bg-amber-500 text-black",
  },

  // 15. ROYAL INDIGO
  ROYAL_INDIGO: {
    name: "Royal Indigo",
    bg: "bg-indigo-950",
    card: "bg-indigo-900",
    nav: "bg-indigo-950",
    text: "text-indigo-100",
    subText: "text-indigo-300",
    accent: "text-amber-300",
    accentBg: "bg-amber-500",
    border: "border-indigo-700",
    glow: "shadow-amber-400/50",
    hover: "hover:bg-indigo-800",
    tabHover: "hover:bg-amber-500 hover:text-black",
    buttonPrimary: "bg-amber-500 hover:bg-amber-600 text-black",
    buttonSecondary: "bg-indigo-700 hover:bg-indigo-600 text-indigo-100",
    tabActive: "bg-amber-500 text-black border-amber-400 shadow-lg shadow-amber-400/50",
    tabInactive: "bg-indigo-900 text-indigo-100 border-indigo-700 hover:bg-indigo-700 hover:text-white",
    danger: "bg-red-600 text-white",
    success: "bg-emerald-500 text-white",
    warning: "bg-amber-400 text-black",
  },

  COFFEE_HOUSE: {
    name: "Coffee House",

    bg: "bg-orange-100",
    card: "bg-yellow-50",

    nav: "bg-gradient-to-r from-stone-900 via-amber-900 to-orange-800 text-amber-100",

    text: "text-stone-900",
    subText: "text-amber-900",

    accent: "text-orange-700",
    accentBg: "bg-orange-800",

    border: "border-amber-400",

    glow: "shadow-orange-900/40",

    hover: "hover:bg-orange-200",

    tabHover: "hover:bg-orange-800 hover:text-white",

    buttonPrimary:
      "bg-orange-800 hover:bg-orange-900 text-white",

    buttonSecondary:
      "bg-stone-700 hover:bg-stone-800 text-amber-100",

    tabActive:
      "bg-orange-800 text-white border-orange-700 shadow-lg shadow-orange-900/40",

    tabInactive:
      "bg-yellow-50 text-stone-900 border-amber-400 hover:bg-orange-800 hover:text-white",

    tableHeader:
      "bg-gradient-to-r from-stone-900 to-orange-800 text-amber-100",

    tableRow:
      "bg-yellow-50 text-stone-900 border-amber-300 hover:bg-orange-100",

    danger: "bg-red-700 text-white",

    success: "bg-emerald-700 text-white",

    warning: "bg-amber-500 text-black",
  },

CAMPUS_JOY: {
    name: "Campus Joy",

    bg: "bg-gradient-to-br from-fuchsia-100 via-violet-100 to-cyan-100",
    card: "bg-white/90 backdrop-blur-sm",

    nav: "bg-gradient-to-r from-fuchsia-600 via-pink-500 to-cyan-500 text-white",

    text: "text-fuchsia-950",
    subText: "text-violet-700",

    accent: "text-cyan-500",
    accentBg: "bg-pink-500",

    border: "border-fuchsia-300",

    glow: "shadow-pink-500/70",

    hover: "hover:bg-fuchsia-100",

    tabHover: "hover:bg-pink-500 hover:text-white",

    buttonPrimary:
      "bg-pink-500 hover:bg-pink-600 text-white",

    buttonSecondary:
      "bg-cyan-500 hover:bg-cyan-600 text-white",

    tabActive:
      "bg-pink-500 text-white border-pink-400 shadow-lg shadow-pink-500/60",

    tabInactive:
      "bg-white text-fuchsia-950 border-fuchsia-300 hover:bg-pink-500 hover:text-white",

    tableHeader:
      "bg-gradient-to-r from-fuchsia-600 via-pink-500 to-cyan-500 text-white",

    tableRow:
      "bg-white text-fuchsia-950 border-fuchsia-200 hover:bg-fuchsia-50",

    danger: "bg-red-600 text-white",

    success: "bg-cyan-500 text-black",

    warning: "bg-amber-400 text-black",
},

HOSTEL_EARTH: {
    name: "Hostel Earth",

    bg: "bg-stone-200",
    card: "bg-stone-50",

    nav: "bg-gradient-to-r from-stone-800 via-stone-700 to-lime-800 text-white",

    text: "text-stone-900",
    subText: "text-stone-700",

    accent: "text-lime-700",
    accentBg: "bg-lime-700",

    border: "border-stone-400",

    glow: "shadow-lime-800/30",

    hover: "hover:bg-stone-300",

    tabHover: "hover:bg-lime-700 hover:text-white",

    buttonPrimary:
      "bg-lime-700 hover:bg-lime-800 text-white",

    buttonSecondary:
      "bg-stone-700 hover:bg-stone-800 text-white",

    tabActive:
      "bg-lime-700 text-white border-lime-600 shadow-lg shadow-lime-700/40",

    tabInactive:
      "bg-stone-50 text-stone-900 border-stone-400 hover:bg-lime-700 hover:text-white",

    tableHeader:
      "bg-gradient-to-r from-stone-800 to-lime-800 text-white",

    tableRow:
      "bg-stone-50 text-stone-900 border-stone-300 hover:bg-stone-100",

    danger: "bg-red-700 text-white",

    success: "bg-lime-700 text-white",

    warning: "bg-amber-500 text-black",
},

// 17. VILLAGE CONNECT — Warm Earthy Rural (Terracotta + Olive + Mustard)
  VILLAGE_CONNECT: {
    name: "Village Connect",
    bg: "bg-amber-50",
    card: "bg-white",
    nav: "bg-gradient-to-r from-amber-700 via-orange-600 to-emerald-700 text-white",
    text: "text-amber-950",
    subText: "text-emerald-800",
    accent: "text-emerald-700",
    accentBg: "bg-orange-600",
    border: "border-amber-300",
    glow: "shadow-orange-600/40",
    hover: "hover:bg-amber-100",
    tabHover: "hover:bg-emerald-700 hover:text-white",
    buttonPrimary: "bg-emerald-700 hover:bg-emerald-800 text-white",
    buttonSecondary: "bg-orange-600 hover:bg-orange-700 text-white",
    tabActive: "bg-emerald-700 text-white border-emerald-600 shadow-lg shadow-orange-500/40",
    tabInactive: "bg-white text-amber-950 border-amber-300 hover:bg-emerald-700 hover:text-white",
    tableHeader: "bg-gradient-to-r from-amber-700 to-emerald-700 text-white",
    tableRow: "bg-white text-amber-950 border-amber-200 hover:bg-amber-50",
    danger: "bg-red-600 text-white",
    success: "bg-emerald-700 text-white",
    warning: "bg-amber-500 text-black",
  },

  // 11. EMERALD CORPORATE — Professional Deep Green (Corporate feel)
  EMERALD_CORPORATE: {
    name: "Emerald Corporate",
    bg: "bg-emerald-50",
    card: "bg-white",
    nav: "bg-emerald-900 text-white",
    text: "text-emerald-950",
    subText: "text-emerald-700",
    accent: "text-teal-700",
    accentBg: "bg-emerald-800",
    border: "border-emerald-200",
    glow: "shadow-emerald-700/40",
    hover: "hover:bg-emerald-100",
    tabHover: "hover:bg-emerald-800 hover:text-white",
    buttonPrimary: "bg-emerald-800 hover:bg-emerald-900 text-white",
    buttonSecondary: "bg-slate-700 hover:bg-slate-800 text-white",
    tabActive: "bg-emerald-800 text-white border-emerald-700 shadow-lg shadow-emerald-700/50",
    tabInactive: "bg-white text-emerald-950 border-emerald-200 hover:bg-emerald-800 hover:text-white",
    tableHeader: "bg-emerald-800 text-white",
    tableRow: "bg-white text-emerald-950 border-emerald-100 hover:bg-emerald-50",
    danger: "bg-red-600 text-white",
    success: "bg-teal-700 text-white",
    warning: "bg-amber-500 text-black",
  },

    // 22. WINTER FROST — Cool Icy (Frosty Blue + Silver)
  WINTER_FROST: {
    name: "Winter Frost",
    bg: "bg-sky-50",
    card: "bg-white",
    nav: "bg-sky-900 text-white",
    text: "text-sky-950",
    subText: "text-sky-700",
    accent: "text-cyan-700",
    accentBg: "bg-sky-700",
    border: "border-sky-200",
    glow: "shadow-sky-500/50",
    hover: "hover:bg-sky-100",
    tabHover: "hover:bg-sky-700 hover:text-white",
    buttonPrimary: "bg-sky-700 hover:bg-sky-800 text-white",
    buttonSecondary: "bg-cyan-600 hover:bg-cyan-700 text-white",
    tabActive: "bg-sky-700 text-white border-sky-600 shadow-lg shadow-sky-600/50",
    tabInactive: "bg-white text-sky-950 border-sky-200 hover:bg-sky-700 hover:text-white",
    danger: "bg-red-600 text-white",
    success: "bg-emerald-600 text-white",
    warning: "bg-amber-400 text-black",
  },

  // 24. AQUA FLOW — Fresh Ocean (Bright Teal + Turquoise)
  AQUA_FLOW: {
    name: "Aqua Flow",
    bg: "bg-teal-50",
    card: "bg-white",
    nav: "bg-gradient-to-r from-teal-600 to-cyan-600 text-white",
    text: "text-teal-950",
    subText: "text-teal-700",
    accent: "text-cyan-600",
    accentBg: "bg-cyan-600",
    border: "border-teal-200",
    glow: "shadow-cyan-500/60",
    hover: "hover:bg-teal-100",
    tabHover: "hover:bg-cyan-600 hover:text-white",
    buttonPrimary: "bg-cyan-600 hover:bg-cyan-700 text-white",
    buttonSecondary: "bg-teal-600 hover:bg-teal-700 text-white",
    tabActive: "bg-cyan-600 text-white border-cyan-500 shadow-lg shadow-cyan-500/60",
    tabInactive: "bg-white text-teal-950 border-teal-200 hover:bg-cyan-600 hover:text-white",
    danger: "bg-red-600 text-white",
    success: "bg-emerald-600 text-white",
    warning: "bg-amber-400 text-black",
  },

  // ===================================
  // 15. NEOBRUTAL OPS (kept brutal feel but improved)
  NEOBRUTAL_OPS: {
    name: "NeoBrutal Ops",
    bg: "bg-yellow-100",
    card: "bg-white",
    nav: "bg-black",
    text: "text-black",
    subText: "text-gray-700",
    accent: "text-blue-800",
    accentBg: "bg-yellow-400",
    border: "border-4 border-black",
    hover: "hover:translate-x-1 hover:-translate-y-1 hover:bg-black hover:text-white",
    tabActive: "bg-yellow-400 text-black border-4 border-black shadow-[5px_5px_0px_0px_rgba(0,0,0,1)]",
    tabInactive: "bg-white text-black border-4 border-black hover:bg-blue-700 hover:text-white",
    tabHover: "hover:bg-blue-700 hover:text-white",
    tableHeader: "bg-black text-yellow-200 border-4 border-black",
    tableRow: "bg-white text-black border-4 border-black hover:bg-yellow-100",
    buttonPrimary: "bg-black hover:bg-gray-900 text-yellow-300 border-4 border-black",
    buttonSecondary: "bg-blue-700 hover:bg-blue-800 text-white border-4 border-black",
    danger: "bg-red-700 text-white border-4 border-black",
    success: "bg-green-700 text-white border-4 border-black",
    warning: "bg-yellow-400 text-black border-4 border-black",
    glow: "shadow-[6px_6px_0px_0px_rgba(0,0,0,1)]",
  },

  // 19. FESTIVAL INDIA
  FESTIVAL_INDIA: {
    name: "Festival India",
    bg: "bg-gradient-to-br from-orange-100 via-pink-100 to-yellow-100",
    card: "bg-white",
    nav: "bg-gradient-to-r from-orange-500 via-pink-500 to-yellow-500 text-white",
    text: "text-orange-950",
    subText: "text-pink-700",
    accent: "text-red-600",
    accentBg: "bg-orange-600",
    border: "border-orange-300",
    glow: "shadow-orange-500/40",
    hover: "hover:bg-orange-50",
    tabHover: "hover:bg-pink-600 hover:text-white",
    buttonPrimary: "bg-orange-600 hover:bg-orange-700 text-white",
    buttonSecondary: "bg-pink-600 hover:bg-pink-700 text-white",
    tabActive: "bg-orange-600 text-white border-orange-400 shadow-lg shadow-orange-500/50",
    tabInactive: "bg-white text-orange-950 border-orange-300 hover:bg-pink-600 hover:text-white",
    danger: "bg-red-600 text-white",
    success: "bg-emerald-600 text-white",
    warning: "bg-amber-400 text-black",
  },

};